import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from 'theme/MainTheme';

const Wrapper = styled.div`
  padding: 2rem 2rem 7rem 2rem;
  color: ${theme.black};
  @media (max-width: 700px) {
    padding-bottom: 16rem;
  }
`;

const Email = styled.span`
  color: ${theme.primary};
  font-weight: ${theme.bold};
`;

const InformationClause = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <p align="center">
        <b>{t('rodo_1')}</b>
      </p>
      <p>{t('rodo_2')}</p>
      <ol>
        <li>
          <p>{t('rodo_3')}</p>
        </li>
      </ol>
      <ol start="2">
        <li>
          <p>{t('rodo_4')}</p>
          <ol>
            <li>{t('rodo_5')}</li>
            <li>
              {t('rodo_6')}
              <Email>daneosobowe@fast-service.com.pl</Email>
            </li>
          </ol>
        </li>
      </ol>
      <ol start="3">
        <li>
          <p>{t('rodo_7')}</p>
          <ol>
            <li>
              <p>{t('rodo_8')}</p>
              <ul>
                <li>
                  <p>{t('rodo_9')}</p>
                </li>
                <li>
                  <p>{t('rodo_10')}</p>
                </li>
                <li>
                  <p>{t('rodo_11')}</p>
                </li>
              </ul>
            </li>
            <li>
              <p>{t('rodo_12')}</p>
              <ul>
                <li>
                  <p>{t('rodo_13')}</p>
                </li>
              </ul>
            </li>
            <li>
              <p>{t('rodo_14')}</p>
              <ul>
                <li>
                  <p>{t('rodo_15')}</p>
                </li>
              </ul>
            </li>
            <li>
              <p>{t('rodo_16')}</p>
              <ul>
                <li>
                  <p>{t('rodo_17')}</p>
                </li>
              </ul>
            </li>
            <li>
              <p>{t('rodo_18')}</p>
              <ul>
                <li>
                  <p>{t('rodo_19')}</p>
                </li>
              </ul>
            </li>
          </ol>
        </li>
      </ol>
      <ol start="4">
        <li>
          <p>{t('rodo_20')}</p>
        </li>
      </ol>
      <ol start="5">
        <li>
          <p>{t('rodo_21')}</p>
          <ol>
            <li>
              <p>{t('rodo_22')}</p>
              <ul>
                <li>
                  <p>{t('rodo_23')}</p>
                </li>
                <li>
                  <p>{t('rodo_24')}</p>
                </li>
              </ul>
            </li>
            <li>
              <p>{t('rodo_25')}</p>
              <ul>
                <li>
                  <p>{t('rodo_26')}</p>
                </li>
              </ul>
            </li>
            <li>
              <p>{t('rodo_27')}</p>
              <ul>
                <li>
                  <p>{t('rodo_28')}</p>
                </li>
              </ul>
            </li>
            <li>
              <p>{t('rodo_29')}</p>
              <ul>
                <li>
                  <p>{t('rodo_30')}</p>
                </li>
              </ul>
            </li>
          </ol>
        </li>
      </ol>
      <ol start="6">
        <li>
          <p>{t('rodo_31')}</p>
        </li>
      </ol>
      <ol start="7">
        <li>
          <p>{t('rodo_32')}</p>
        </li>
      </ol>
      <ol start="8">
        <li>
          <p>
            {t('rodo_33')}
            <ul>
              <li>
                <p>{t('rodo_34')}</p>
              </li>
              <li>
                <p>{t('rodo_35')}</p>
              </li>
              <li>
                <p>{t('rodo_36')}</p>
              </li>
              <li>
                <p>{t('rodo_37')}</p>
              </li>
              <li>
                <p>{t('rodo_38')}</p>
              </li>
              <li>
                <p>{t('rodo_39')}</p>
              </li>
            </ul>
          </p>
        </li>
      </ol>
      <ol start="9">
        <li>
          <p>{t('rodo_40')}</p>
        </li>
      </ol>
      <ol start="10">
        <li>
          <p>{t('rodo_41')}</p>
        </li>
      </ol>
    </Wrapper>
  );
};

export default InformationClause;
